<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Application Types</h1>
      </v-toolbar-title>
    </v-toolbar>
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="appTypes"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item ? item.name : "---" }}
          </td>
          <td class="table__cell text-center">
            <v-icon class="name" @click="showPhases(item)">mdi-eye</v-icon>

            <!-- <span v-else>---</span>
             v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              " 
              v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              "
              -->
          </td>
          <td class="table__cell text-center">
            <v-icon title="Priority" @click="prioritize(item)"
              >mdi-priority-high</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1100px">
      <PhasesDialog
        :appTypePhases="appTypePhases"
        :phases="phases"
        :appData="appData"
        @closeDialog="closeDialog"
      />
    </v-dialog>
    <v-dialog v-model="priority" max-width="500px">
      <PriorityDialog
        :appData="appData"
        @closePriorityDialog="closePriorityDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, ShowData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      appData: {},
      dialog: false,
      priority: false,
      loading: false,
      headers: [],
      appTypes: [],
      phases: [],
      appTypePhases: [],
      loadingDataTable: false
    };
  },
  components: {
    PhasesDialog: () => import("./components/PhasesDialog"),
    PriorityDialog: () => import("./components/PriorityDialog")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexAppTypes();
  },
  methods: {
    indexAppTypes() {
      this.loadingDataTable = true;
      IndexData({ reqName: `hr/application-types` })
        .then(res => {
          const { data } = res.data;
          this.appTypes = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },

    showPhases({ id }) {
      this.dialog = true;

      ShowData({
        reqName: `hr/application-types`,
        id: id
      })
        .then(res => {
          const { application_type } = res.data;
          this.appTypePhases = application_type.phases;
          this.appData = application_type;
        })
        .catch(() => {});
      IndexData({ reqName: `/hr/phases` })
        .then(res => {
          this.phases = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Name", "Phases", "Phases Priority"];
      this.headers = TableHeaders(headersList);
    },
    closeDialog() {
      this.dialog = false;
      this.appTypePhases = [];
    },
    closePriorityDialog() {
      this.priority = false;
      this.appData = {};
    },
    prioritize({ id }) {
      this.priority = true;
      ShowData({
        reqName: `hr/application-types`,
        id: id
      })
        .then(res => {
          const { application_type } = res.data;
          this.appData = application_type;
        })
        .catch(() => {});
    }
  }
};
</script>
